module.exports = __webpack_public_path__ + "static/chris-davis-5d33ae698f69ba841f2fde8ff3e2c531.jpg";